import React, { useEffect, useMemo, useState } from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { global } from "@shared/libs/Global";
import { formatNumber, toNum } from "@shared/utils/CommonUtils";
import { icoPur01 } from "./icons";

interface Props {
  cdWidget?: string;
  nmWidget?: string;
  searchData?: any;
  refreshKey?: number;
}

// sn_sys_widget_006(구매현황) 기반. 상세는 sn_sys_widget_012_01 팝업.
const SnSysWidget012: React.FC<Props> = ({
  nmWidget,
  searchData,
  refreshKey,
}) => {
  const { userInfo } = global();
  const [dataSource, setDataSource] = useState<any>();

  const params = useMemo(
    () => ({
      cd_firm: searchData?.cd_firm || userInfo.cd_firm,
      dt: searchData?.dt,
    }),
    [searchData?.cd_firm, searchData?.dt, userInfo.cd_firm]
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const param = {
          id: "sn_sys_widget_012_01",
          params,
        };
        const data: any = await fnGetDataSet(param);
        setDataSource(data?.[0]?.[0] || {});
      } catch (error) {}
    };

    fetchData();
  }, [params, refreshKey]);

  const rows = [
    {
      label: "구매금액",
      value: formatNumber(toNum(dataSource?.am_k), { fractionDigits: 0 }),
      unit: "만원",
    },
    {
      label: "발주건수",
      value: formatNumber(toNum(dataSource?.qt_cnt_po), { fractionDigits: 0 }),
      unit: "건",
    },
    {
      label: "입고건수",
      value: formatNumber(toNum(dataSource?.qt_cnt_rcv), {
        fractionDigits: 0,
      }),
      unit: "건",
    },
    {
      label: "납기지연건수",
      value: formatNumber(toNum(dataSource?.qt_delay), { fractionDigits: 0 }),
      unit: "건",
    },
    {
      label: "납기준수율",
      value: formatNumber(toNum(dataSource?.rt_ontime), { fractionDigits: 1 }),
      unit: "%",
    },
  ];

  return (
    <div className="flex h-full min-h-[224px] w-full flex-col rounded-lg border border-gray-100 bg-white px-4 py-3 shadow-sm">
      <div className="mb-5 flex items-center gap-3">
        <div className="aspect-square h-10 shrink-0">
          <img src={icoPur01} alt="" className="h-full w-full object-contain" />
        </div>
        <div className="truncate text-xl font-bold text-slate-900">{nmWidget}</div>
      </div>

      <div className="flex flex-col gap-2.5">
        {rows.map((row) => (
          <div
            key={row.label}
            className="flex items-baseline justify-between gap-3 text-base font-semibold"
          >
            <span className="shrink-0 text-slate-800">{row.label}</span>
            <span className="min-w-0 whitespace-nowrap text-right text-slate-900">
              {row.value}
              <span className="ml-1 text-sm font-semibold text-slate-700">
                {row.unit}
              </span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SnSysWidget012;
